module.exports = __webpack_public_path__ + "static/media/accHome.4748d340.svg";